<svg
  width="26"
  height="22"
  viewBox="0 0 26 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M20.4765 0H24.4634L15.7533 9.25121L26 21.84H17.9769L11.6929 14.205L4.50267 21.84H0.51342L9.82969 11.9448L0 0H8.22677L13.9069 6.97872L20.4765 0ZM19.0773 19.6224H21.2864L7.02639 2.10113H4.65575L19.0773 19.6224Z"
    fill="currentColor"
  />
</svg>
